import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { Accordion, AccordionItem } from '@jouzen/ecom-components/v4/Accordion';
import { useTranslations } from 'next-intl';

import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';
import Motion from '@/app/components/Motion';
import RichText from '@/app/components/RichText';

import data from '../_data/activityAndMovementTrackingData';

const accordionItemClassName = 'bg-sandstone-400 text-brown-600';

const ActivityAndMovementTracking = () => {
  const t = useTranslations();
  return (
    <section
      className="bg-sandstone-200 pt-8 lg:pt-20"
      data-cy="activity-and-movement-tracking"
    >
      <LayoutGrid rowGap={32} className="h-full">
        <GridItem
          className="aspect-square self-center overflow-hidden rounded-lg lg:mx-10 lg:aspect-5/6"
          colStart={{ sm: 'main', md: 6, lg: 'main' }}
          colEnd={{ sm: 'main', md: 20, lg: 13 }}
          rowStart={{ sm: 1 }}
        >
          <Motion
            className="relative h-full"
            initial={{ filter: 'blur(5px)', opacity: 0 }}
            whileInView={{ filter: 'blur(0px)', opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2, type: 'tween' }}
          >
            <ArtDirectionImage
              className="rounded-lg object-cover"
              fill
              localizedAlt="activity_tracking_img_alt"
              priority
              sizes="100vw"
              srcSet={[
                {
                  media: '(max-width: 1023px)',
                  src: 'activity-and-movement/activity-tracking.jpg?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.44&fp-z=1',
                },
                {
                  media: '(min-width: 1024px)',
                  src: 'activity-and-movement/activity-tracking.jpg?ar=5:6&fit=crop&crop=focalpoint&fp-x=0.45&fp-y=0.42&fp-z=1.05',
                },
              ]}
            />
          </Motion>
        </GridItem>
        <GridItem
          className="flex flex-col justify-center p-0 lg:px-10"
          colStart={{ sm: 'main', md: 6, lg: 13 }}
          colEnd={{ sm: 'main', md: 20, lg: 'main' }}
          rowStart={{ sm: 2, lg: 1 }}
        >
          <Motion
            initial={{ filter: 'blur(5px)', opacity: 0 }}
            whileInView={{ filter: 'blur(0px)', opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2, type: 'tween' }}
          >
            <Typography
              variant="h4"
              height="tight"
              className="mb-3 font-normal tracking-tighter text-balance text-brown-600 md:text-wrap"
            >
              <RichText messageKey="activity_tracking_title" />
            </Typography>
            <Typography variant="body-small" className="mb-3 text-brown-600">
              {t('activity_tracking_copy')}
            </Typography>
            <Accordion>
              {data.map(({ Icon, ...highlight }) => (
                <AccordionItem
                  key={highlight.id}
                  className={accordionItemClassName}
                  header={t(highlight.header)}
                  icon={<Icon className="w-6" />}
                >
                  {t(highlight.content)}
                </AccordionItem>
              ))}
            </Accordion>
          </Motion>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default ActivityAndMovementTracking;
